import React, { Component, useState } from 'react'
import client from "./../../utils/apolloClient";
import getData from "./../../data-services/api";
import { getUser } from "./../../data-services/queries";
import gql from "graphql-tag";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import { Table, TableRow, TableCell, TableHead, TableBody } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ThumbnailIcon from "./../Home/icons/6.png";
import IconButton from "@material-ui/core/IconButton";
import './Fevicryl.css';
import Loader from "./../../components/CustomLoader";
import _ from "lodash";
import { IoArrowForwardCircleOutline } from "react-icons/io5";
import { VscSettings } from "react-icons/vsc";
import { TbFilter } from "react-icons/tb";
import { IoSearchSharp } from "react-icons/io5";
import { Link } from 'react-router-dom';

export default class FevicyrlContent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            FCCAll: [],
            FCC: [],
            SEASONALITY: [],
            CRAFT_CATEGORY: [],
            TIME_PERIOD: [],
            DIFFICULTY: [],
            searchTerm: '',
            fevicyrl: {
                seasonality__c: "",
                craft_category__c: ""
            },
        };

    }

    async componentDidMount() {
        await client
            .query({
                query: gql(getUser)
            })
            .then(({ data }) => {
                if (data.user.role === "CMDI" || data.user.role === "AMMD") {
                    this.setState({
                        userData: data.user
                    });
                }
            });

        function getUniqueListBy(arr, key) {
            return [...new Map(arr.map((item) =>
                [item[key], item]
            )).values()];
        }

        let FCCAllResult;
        FCCAllResult = await getData(
            `select id, Craft_Category__c, In_House_Products_Used__c, Level_Of_Difficulty__c, Link_In_Pil_Tantra__c, Name, Non_Pil_Product_Price__c, Out_Sourced_Products_Use__c, Pil_Product_Price__c, Seasonality__c, Time_Period__c,Thumbnail_URL__c, Total_Cost_of_making_the_article__c from Salesforce.Content_Categorization__c`
        )
        //console.log("FCC Data", FCCAllResult.result);

        const SEASONALITY = getUniqueListBy(FCCAllResult.result, "seasonality__c");
        const CRAFT_CATEGORY = getUniqueListBy(FCCAllResult.result, "craft_category__c");
        const TIME_PERIOD = getUniqueListBy(FCCAllResult.result, "time_period__c");
        const DIFFICULTY = getUniqueListBy(FCCAllResult.result, "level_of_difficulty__c");

        this.setState({
            FCCAll: FCCAllResult.result,
            FCC: FCCAllResult.result,
            SEASONALITY: SEASONALITY,
            CRAFT_CATEGORY: CRAFT_CATEGORY,
            TIME_PERIOD: TIME_PERIOD,
            DIFFICULTY: DIFFICULTY,
            loading: false
        });
    }

    handleChange = (e) => {
        if (e.target.name == "seasonality__c") {
            this.setState({
                fevicyrl: {
                    seasonality__c: e.target.value,
                    craft_category__c: "",
                    time_period__c: "",
                    level_of_difficulty__c: ""
                }
            });
            this.state.FCC = this.state.FCCAll.filter(FCCAll => {
                return FCCAll.seasonality__c === e.target.value
            });
        }
        if (e.target.name == "craft_category__c") {
            this.setState({
                fevicyrl: {
                    seasonality__c: this.state.fevicyrl.seasonality__c,
                    craft_category__c: e.target.value,
                    time_period__c: "",
                    level_of_difficulty__c: ""
                }
            });
            this.state.FCC = this.state.FCCAll.filter(FCCAll => {
                return FCCAll.craft_category__c === e.target.value && FCCAll.seasonality__c === this.state.fevicyrl.seasonality__c;
            });
        }
        if (e.target.name == "time_period__c") {
            this.setState({
                fevicyrl: {
                    seasonality__c: this.state.fevicyrl.seasonality__c,
                    craft_category__c: this.state.fevicyrl.craft_category__c,
                    time_period__c: e.target.value,
                    level_of_difficulty__c: ""
                }
            });
            this.state.FCC = this.state.FCCAll.filter(FCCAll => {
                return FCCAll.time_period__c === e.target.value && FCCAll.seasonality__c === this.state.fevicyrl.seasonality__c
                    && FCCAll.craft_category__c === this.state.fevicyrl.craft_category__c;
            });
        }
        if (e.target.name == "level_of_difficulty__c") {
            this.setState({
                fevicyrl: {
                    seasonality__c: this.state.fevicyrl.seasonality__c,
                    craft_category__c: this.state.fevicyrl.craft_category__c,
                    time_period__c: this.state.fevicyrl.time_period__c,
                    level_of_difficulty__c: e.target.value
                }
            });
            this.state.FCC = this.state.FCCAll.filter(FCCAll => {
                return FCCAll.level_of_difficulty__c === e.target.value && FCCAll.seasonality__c === this.state.fevicyrl.seasonality__c
                    && FCCAll.craft_category__c === this.state.fevicyrl.craft_category__c && FCCAll.time_period__c === this.state.fevicyrl.time_period__c;
            });
        }
    };


    handleInputChange = (e) => {
        var value = e.target.value.toUpperCase();
        this.setState({
            searchTerm: value
        });

    };

    handleSearch = () => {
        // onSearch(searchTerm);
    };

    gotoWorkshop = (item) => {
        this.props.history.push({
            pathname: "/fevicryl-Details",
            productData: item
        });
    };

    render() {
        const { FCCAll, fevicyrl, FCC, SEASONALITY, CRAFT_CATEGORY, TIME_PERIOD, DIFFICULTY, loading, searchTerm } = this.state;
        const { classes, history, } = this.props;


        return (
            <>
                <AppBar position="static">
                    <Toolbar>
                        <Grid item xs={2} sm={2} md={2}>
                            <IconButton
                                color="inherit"
                                aria-label="Menu"
                                onClick={() => {
                                    history.goBack();
                                }}
                            >
                                <ArrowBackIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={8} sm={8} md={8}>
                            <Typography
                                variant="title"
                                color="inherit"
                                className='text-center'
                            >
                                Fevicryl Content Categorization
                            </Typography>
                        </Grid>
                    </Toolbar>
                </AppBar>
                {loading ? (
                    <Grid container alignItems="center" justify="center">
                        <Loader type="Audio" color="#00BFFF" height="50" width="50" />
                    </Grid>
                ) : (
                    <>
                        <div className='d-none d-md-block'>
                            <div className='d-flex fevicyrlContent__outerFilterBox'>
                                <div className='fevicyrlContent__selectBox'>
                                    <Select
                                        native
                                        name="seasonality__c"
                                        onChange={this.handleChange}
                                        className='fevicyrlContent__fevicyrlFilters'
                                    >
                                        <option>Seasonality</option>
                                        {SEASONALITY && SEASONALITY.map((item) => {
                                            return (
                                                <>
                                                    <option value={item.seasonality__c} className='fevicyrlContent__filterLabel' >{item.seasonality__c}</option>
                                                </>
                                            );
                                        })}
                                    </Select>
                                </div>
                                <div className='fevicyrlContent__selectBox'>
                                    <Select
                                        native
                                        name="craft_category__c"
                                        value={fevicyrl.craft_category__c}
                                        onChange={this.handleChange}
                                        className='fevicyrlContent__fevicyrlFilters'
                                    >
                                        <option value="">Craft Category</option>
                                        {CRAFT_CATEGORY && CRAFT_CATEGORY.map((item) => {
                                            return (
                                                <>
                                                    <option value={item.craft_category__c} className='fevicyrlContent__filterLabel'>{item.craft_category__c}</option>
                                                </>
                                            );
                                        })}
                                    </Select>
                                </div>
                                <div className='fevicyrlContent__selectBox'>
                                    <Select
                                        native
                                        // name="time_period__c"
                                        value={fevicyrl.time_period__c}
                                        onChange={this.handleChange}
                                        className='fevicyrlContent__fevicyrlFilters'
                                    >
                                        <option value="">Time Period</option>
                                        {TIME_PERIOD.map((item) => {
                                            return (
                                                <>
                                                    <option value={item.time_period__c} className='fevicyrlContent__filterLabel'>{item.time_period__c}</option>
                                                </>
                                            );
                                        })}
                                    </Select>
                                </div>
                                <div className='fevicyrlContent__selectBox'>
                                    <Select
                                        native
                                        name="level_of_difficulty__c"
                                        value={fevicyrl.level_of_difficulty__c}
                                        onChange={this.handleChange}
                                        className='fevicyrlContent__fevicyrlFilters'
                                    >
                                        <option value="">Difficulty Level</option>
                                        {DIFFICULTY && DIFFICULTY.map((item) => {
                                            return (
                                                <>
                                                    <option value={item.level_of_difficulty__c} className='fevicyrlContent__filterLabel'>{item.level_of_difficulty__c}</option>
                                                </>
                                            );
                                        })}
                                    </Select>
                                </div>
                            </div>
                        </div>

                        <div className='d-block d-md-none'>
                            <div className='d-flex mt-3'>
                                <div className='fevicyrlContent__search_bar'>
                                    <input
                                        type="text"
                                        placeholder="Search User"
                                        // value={searchTerm}
                                        onChange={this.handleInputChange}
                                        className='fevicyrlContent__searchInput w-100'
                                    />
                                    <button onClick={this.handleSearch} className='fevicyrlContent__searchButton'>
                                        <IoSearchSharp className='fevicyrlContent__searchButtonIcon' />
                                    </button>
                                </div>
                                <div className='fevicyrlContent__settingBox'>
                                    <button>
                                        <VscSettings className='fevicyrlContent__settingIcon' />
                                    </button>

                                </div>

                                <div className="dropdown fevicyrlContent__dropDownFilter">
                                    <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                        <TbFilter className='fevicyrlContent__filterIcon' />
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <li>
                                            <div className='fevicyrlContent__selectMobBox'>
                                                <Select
                                                    native
                                                    name="seasonality__c"
                                                    onChange={this.handleChange}
                                                    className='fevicyrlContent__fevicyrlMobFilters'
                                                >
                                                    <option>Seasonality</option>
                                                    {SEASONALITY && SEASONALITY.map((item) => {
                                                        return (
                                                            <>
                                                                <option value={item.seasonality__c} className='fevicyrlContent__filterLabel' >{item.seasonality__c}</option>
                                                            </>
                                                        );
                                                    })}
                                                </Select>
                                            </div>
                                        </li>
                                        <li>
                                            <div className='fevicyrlContent__selectMobBox'>
                                                <Select
                                                    native
                                                    name="craft_category__c"
                                                    value={fevicyrl.craft_category__c}
                                                    onChange={this.handleChange}
                                                    className='fevicyrlContent__fevicyrlMobFilters'
                                                >
                                                    <option value="">Craft Category</option>
                                                    {CRAFT_CATEGORY && CRAFT_CATEGORY.map((item) => {
                                                        return (
                                                            <>
                                                                <option value={item.craft_category__c} className='fevicyrlContent__filterLabel'>{item.craft_category__c}</option>
                                                            </>
                                                        );
                                                    })}
                                                </Select>
                                            </div>
                                        </li>
                                        <li>
                                            <div className='fevicyrlContent__selectMobBox'>
                                                <Select
                                                    native
                                                    // name="time_period__c"
                                                    value={fevicyrl.time_period__c}
                                                    onChange={this.handleChange}
                                                    className='fevicyrlContent__fevicyrlMobFilters'
                                                >
                                                    <option value="">Time Period</option>
                                                    {TIME_PERIOD.map((item) => {
                                                        return (
                                                            <>
                                                                <option value={item.time_period__c} className='fevicyrlContent__filterLabel'>{item.time_period__c}</option>
                                                            </>
                                                        );
                                                    })}
                                                </Select>
                                            </div>
                                        </li>
                                        <li>
                                            <div className='fevicyrlContent__selectMobBox'>
                                                <Select
                                                    native
                                                    name="level_of_difficulty__c"
                                                    value={fevicyrl.level_of_difficulty__c}
                                                    onChange={this.handleChange}
                                                    className='fevicyrlContent__fevicyrlMobFilters'
                                                >
                                                    <option value="">Difficulty Level</option>
                                                    {DIFFICULTY && DIFFICULTY.map((item) => {
                                                        return (
                                                            <>
                                                                <option value={item.level_of_difficulty__c} className='fevicyrlContent__filterLabel'>{item.level_of_difficulty__c}</option>
                                                            </>
                                                        );
                                                    })}
                                                </Select>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className='container-fluid'>
                            <div className='row fevicyrlContent__fevicyrlRow'>
                                {FCC.filter((item) => {
                                    return searchTerm.toUpperCase() === '' ? item :
                                        item.name.toUpperCase().includes(searchTerm)
                                }).map((row, index) => {
                                    return (
                                        <>
                                            <div className='col-lg-2 col-md-4 col-6'>
                                                <div className='fevicyrlContent__productBox'>
                                                    <img src={row.thumbnail_url__c} alt="ThumbnailIcon" />
                                                    <p>{row.name}</p>
                                                    <div>
                                                        {/* <Link to={`/fevicryl-Content/${row.id}`}> */}
                                                        <IoArrowForwardCircleOutline className='fevicyrlContent__forwardArrow' onClick={() => this.gotoWorkshop(row)} />
                                                        {/* </Link> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )
                                }
                                )}
                            </div>
                        </div>
                    </>
                )}
            </>
        )
    }
}
